/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";

export type SuppressExpensesOutsideProjectPeriodWarningInput = {
    projectId: string;
    csrfToken?: string | null | undefined;
    socketClientId?: string | null | undefined;
    clientMutationId?: string | null | undefined;
};
export type suppressExpensesOutsideProjectPeriodWarningMutationVariables = {
    input: SuppressExpensesOutsideProjectPeriodWarningInput;
};
export type suppressExpensesOutsideProjectPeriodWarningMutationResponse = {
    readonly suppressExpensesOutsideProjectPeriodWarning: {
        readonly clientMutationId: string | null;
    } | null;
};
export type suppressExpensesOutsideProjectPeriodWarningMutation = {
    readonly response: suppressExpensesOutsideProjectPeriodWarningMutationResponse;
    readonly variables: suppressExpensesOutsideProjectPeriodWarningMutationVariables;
};



/*
mutation suppressExpensesOutsideProjectPeriodWarningMutation(
  $input: SuppressExpensesOutsideProjectPeriodWarningInput!
) {
  suppressExpensesOutsideProjectPeriodWarning(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "SuppressExpensesOutsideProjectPeriodWarningInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SuppressExpensesOutsideProjectPeriodWarningPayload",
    "kind": "LinkedField",
    "name": "suppressExpensesOutsideProjectPeriodWarning",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "suppressExpensesOutsideProjectPeriodWarningMutation",
    "operationKind": "mutation",
    "text": "mutation suppressExpensesOutsideProjectPeriodWarningMutation(\n  $input: SuppressExpensesOutsideProjectPeriodWarningInput!\n) {\n  suppressExpensesOutsideProjectPeriodWarning(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '5fa079b7934db9785266c805bb0f7eeb';
export default node;
